import { render, staticRenderFns } from "./RestartsTable.vue?vue&type=template&id=9a5eb9ac&"
import script from "./RestartsTable.vue?vue&type=script&lang=js&"
export * from "./RestartsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports